export default {
    ACCOUNT: '/account',
    NOT_FOUND: '/not-found',
};
